import { fetchDestinationBySlug } from "../api/destinationApi";
import { fetchCampDetail } from "../api/exploreApi";
import { fetchSafariDetail } from "../api/safariApi";
import { fetchCruiseDetail } from "../api/cruiseApi";
import { fetchTrekDetail } from "../api/trekApi";

const prefetches = new Map();
const MAX_PREFETCH_REGISTRY_ENTRIES = 80;

const segmentsFor = (href = "") => {
  try {
    const url = new URL(String(href || ""), "https://ecotour.local");
    return url.pathname.split("/").filter(Boolean).map(decodeURIComponent);
  } catch {
    return [];
  }
};

const buildPrefetchTasks = (href) => {
  const segments = segmentsFor(href);
  if (segments[0] === "destination" && segments[1]) {
    return [
      () => import("../Pages/DestinationDetails"),
      () => fetchDestinationBySlug(segments[1], { view: "compact" }),
    ];
  }
  if (segments[0] === "stays-camps" && segments[1] && segments[2]) {
    return [
      () => import("../Pages/Explore/ExploreCampRoute"),
      () => fetchCampDetail(segments[1], segments[2], { view: "compact" }),
    ];
  }
  if (["experiences", "jungle-safaris"].includes(segments[0]) && segments[1] && segments[2]) {
    return [
      () => import("../Pages/Explore/ExploreJungleSafari"),
      () => fetchSafariDetail(segments[1], segments[2], { view: "compact" }),
    ];
  }
  if (segments[0] === "cruise-boating" && segments[1] && segments[2]) {
    return [
      () => import("../Pages/Explore/ExploreCruiseBoating"),
      () => fetchCruiseDetail(segments[1], segments[2], { view: "compact" }),
    ];
  }
  if (["treks-trails", "track-trails"].includes(segments[0]) && segments[1]) {
    const [destinationSlug, trekSlug] = segments.length >= 3
      ? [segments[1], segments[2]]
      : ["", segments[1]];
    return [
      () => import("../Pages/Explore/ExploreTrekTrail"),
      () => fetchTrekDetail(destinationSlug, trekSlug, { view: "compact" }),
    ];
  }
  if (segments[0] === "district" && segments[1]) {
    return [() => import("../Pages/Explore/ExploreDistrict")];
  }
  if (segments[0] === "packages" && segments[1]) {
    return [() => import("../Pages/Packages/PackageDetailPage")];
  }
  return [];
};

export const prefetchLandingCardRoute = (href = "") => {
  const key = String(href || "").split(/[?#]/, 1)[0];
  if (!key || prefetches.has(key)) return prefetches.get(key) || Promise.resolve(false);
  const tasks = buildPrefetchTasks(key);
  if (!tasks.length) return Promise.resolve(false);
  while (prefetches.size >= MAX_PREFETCH_REGISTRY_ENTRIES) {
    prefetches.delete(prefetches.keys().next().value);
  }

  const request = Promise.allSettled(tasks.map((task) => Promise.resolve().then(task)))
    .then((results) => {
      const successful = results.every((result) => result.status === "fulfilled");
      if (!successful && prefetches.get(key) === request) prefetches.delete(key);
      return successful;
    })
    .catch(() => {
      if (prefetches.get(key) === request) prefetches.delete(key);
      return false;
    });
  prefetches.set(key, request);
  return request;
};

export const __getRoutePrefetchRegistrySizeForTests = () => prefetches.size;

export const __resetRoutePrefetchForTests = () => prefetches.clear();
